import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import SoftInput from "components/SoftInput";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import { Button, MenuItem, Grid, Paper, Card } from '@mui/material';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import SoftTypography from 'components/SoftTypography';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import CustomSelect from '../../components/atoms/CustomSelect'
import service from '../../api/services';
import { useNavigate, useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { AutoComplete } from '../../components/atoms';
import LimitTags from 'components/MultiTag';
import { DATA_LIMIT } from 'utils/api';

const statuses = [{ name: 'ACTIVE' }, { name: 'INACTIVE' }];
const types = [{ name: 'Buy One Get One' }, { name: 'Percentage OFF' }];
const optionSchema = Yup.object({
    label: Yup.string().required('Label is required'),
    value: Yup.string().required('Value is required'),
}).required('required');


const validationSchema = Yup.object({
    offerName: Yup.string().required('Offer Name is required'),
    description: Yup.string().required('Description is required'),
    status: Yup.string().required('Status is required'),
    type: Yup.string().required('Type is required'),
    category: Yup.mixed()
        .test(
            'is-valid-category',
            'Category is required',
            (value) => value && typeof value === 'object' && !!value.label && !!value.value
        ),
    subCategory: Yup.mixed()
        .nullable()
        .test(
            'is-valid-sub-category',
            'Sub Category is required',
            (value) => value && typeof value === 'object' && !!value.label && !!value.value
        ),
    business: Yup.array()
        .of(optionSchema)
        .min(1, 'At least one business is required')
        .required('Bussiness is required'),
    startDate: Yup.date().required('Start Date is required'),
    endDate: Yup.date().required('End Date is required'),
    usageCount: Yup.number().required('Usage Count is required').min(1, 'Must be at least 1'),
});

const CreateOfferForm = () => {
    const params = useParams()
    const [categoryData, setCategoryData] = useState([]);
    const [subCategoryData, setSubCategoryData] = useState([]);
    const [businessData, setBusinessData] = useState([]);
    const navigate = useNavigate()
    const formik = useFormik({
        initialValues: {
            offerName: '',
            description: '',
            status: '',
            type: '',
            category: null,
            subCategory: null,
            business: [],
            startDate: '',
            endDate: '',
            usageCount: '',
        },
        validationSchema,
        onSubmit: async (values) => {
            try {
                const payload = {
                    name: values.offerName,
                    type: values.type,
                    description: values.description,
                    startDate: values.startDate,
                    endDate: values.endDate,
                    usageCount: values.usageCount,
                    category: values.category.value,
                    status: values.status,
                    // business: values.business,
                    subCategory: values.subCategory.value,
                    businesses: values.business
                        ? values?.business?.map((b) => ({
                            businessId: b.businessId,
                            businessUserId: b.value,
                        }))
                        : [],
                };
                const response = params?.id
                    ? await service.offer.edit(params.id, payload)
                    : await service.offer.add(payload);
                if ([200, 201].includes(response.status)) {
                    toast.success(response?.data?.message || 'offer saved successfully.');
                    navigate(-1);
                } else {
                    toast.error(response?.data?.message || 'Failed to save offer.');
                }
            } catch (error) {
                const errMsg = error?.response?.data?.message || 'Something went wrong while submitting.';
                toast.error(errMsg);
                console.error('Submission error:', error);
            }
        },
    });
    function formatDateTimeLocal(dateString) {
        if (!dateString) return '';
        const date = new Date(dateString);
        const pad = (n) => n.toString().padStart(2, '0');

        const yyyy = date.getFullYear();
        const mm = pad(date.getMonth() + 1);
        const dd = pad(date.getDate());
        const hh = pad(date.getHours());
        const min = pad(date.getMinutes());

        return `${yyyy}-${mm}-${dd}T${hh}:${min}`;
    }
    const renderField = ({
        label,
        name,
        type = 'text',
        isSelect = false,
        options = [],
        isAutoComplete = false,
        isDisabled = false,
        isMultiple = false,
        placeholder = '',
        onInputChange
    }) => (
        <SoftBox sx={{ width: '100%' }}>
            <SoftTypography component="label" variant="caption" fontWeight="bold">
                {label}<span style={{ color: 'red' }}>*</span>
            </SoftTypography>
            {isAutoComplete ?
                <>

                    <AutoComplete
                        fullWidth
                        name={name}
                        options={options || []}
                        value={formik.values[name]}
                        placeholder={placeholder}
                        onInputChange={(value) => {
                            if (isAutoComplete) {
                                if (name === 'category') {
                                    getAllCategory(value || '')
                                } else if (formik?.values?.category && formik?.values?.category?.value && name === 'subCategory') {
                                    getDetailById(formik?.values?.category?.value, value || '')
                                } else if (name === 'business') {
                                    getBussinessList(value || '')
                                }
                                // onInputChange(value);  // trigger debounced API call
                            }
                        }}
                        onChange={(e, value) => formik.setFieldValue(name, value)}
                        onBlur={() => formik.setFieldTouched(name, true)}
                        error={formik?.touched?.[name] && Boolean(formik?.errors?.[name])}
                        multiple={isMultiple}
                        disabled={isDisabled}
                        invalid={formik.touched[name] && Boolean(formik?.errors?.[name])}
                    />

                    {/* {formik.touched.category && formik.errors.category && (
                        <SoftTypography variant="caption" color="error" sx={{color:'red'}}>
                            {formik.errors.category}
                        </SoftTypography>
                    )} */}
                </>

                : isSelect ?
                    <CustomSelect
                        options={options}
                        name={name}
                        type={type}
                        select={isSelect}
                        placeholder={label}
                        value={formik.values[name]}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched[name] && Boolean(formik.errors[name])}

                    />
                    : <SoftInput
                        name={name}
                        type={type}
                        select={isSelect}
                        placeholder={label}
                        value={formik.values[name]}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched[name] && Boolean(formik.errors[name])}
                    >
                        {/* {isSelect &&
                    options.map((option) => (
                        <MenuItem key={option} value={option}>
                            {option}
                        </MenuItem>
                    ))} */}
                    </SoftInput>}

            {formik.touched[name] && formik.errors[name] && (
                <SoftTypography variant="caption" color="error" sx={{ color: 'red' }}>
                    {formik.errors[name]}
                </SoftTypography>
            )}
        </SoftBox>
    );
    const getAllCategory = async (value = "") => {
        try {
            const response = await service.categories.view({ show: 1, limit: DATA_LIMIT, searchData: value });
            if (response?.data?.data) {
                setCategoryData(
                    response?.data?.data?.map((item) => ({
                        ...item,
                        label: item.name,
                        value: item._id,
                    }))
                );
            }

        } catch (error) {
            console.error("Failed to fetch business users", error);
        }
    };


    const getDetailById = async (id, value = '') => {
        try {
            // Fetch subcategory data
            const subCategoryRes = await service.categories.getSubCategoryById(id, { searchData: value });

            if (subCategoryRes?.data?.data) {
                setSubCategoryData(
                    subCategoryRes.data.data.map((item) => ({
                        ...item,
                        label: item.name,
                        value: item._id,
                    }))
                );
            }


        } catch (error) {
            console.error("Failed to fetch subcategory or business data:", error);
        }
    };

    const getBussinessList = async (value = '') => {
        try {
            const businessRes = await service.users.view({ userType: 'BUSINESS', limit: DATA_LIMIT, searchData: value });
            if (businessRes?.data?.data) {
                setBusinessData(
                    businessRes.data.data.map((item) => ({
                        ...item,
                        label: item.firstName,
                        value: item._id,
                    }))
                );
            }
        } catch (error) {
            console.error("Failed to fetch subcategory or business data:", error);
        }
    }

    const getOfferDetailById = async () => {
        try {
            const res = await service.offer.getDetailById(params.id);


            const data = res?.data?.data;
            console.log(data?.startDate, data?.endDate)
            formik.setValues({
                offerName: data?.name || '',
                description: data?.description || '',
                status: data?.status || '',
                type: data?.type || '',
                category: data?.category
                    ? {
                        ...data.category,
                        label: data.category.name,
                        value: data.category._id,
                    }
                    : '',
                subCategory: data?.subCategory
                    ? {
                        ...data.subCategory,
                        label: data.subCategory.name,
                        value: data.subCategory._id,
                    }
                    : '',
                business: Array.isArray(data?.businesses)
                    ? data.businesses.map(b => ({
                        ...b,
                        value: b.businessUserId?._id,
                        label: b.businessUserId?.firstName,
                    }))
                    : [],

                usageCount: data?.usageCount || '',
                startDate: data?.startDate ? formatDateTimeLocal(data.startDate) : '',
                endDate: data?.endDate ? formatDateTimeLocal(data.endDate) : ' ',
            });

        } catch (error) {
            console.error("Failed to fetch keyword detail:", error);
        }
    };


    useEffect(() => {
        getBussinessList()
        getAllCategory()
        if (params?.id) {
            getOfferDetailById()
        }
    }, [params?.id])

    useEffect(() => {
        if (formik?.values?.category) {
            getDetailById(formik?.values?.category?.value)
        }
    }, [formik?.values?.category])
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <SoftBox
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    // height: "75vh",
                }}
                gap={3}
                mt={3}
            >
                <Card
                    className="glassmorphism-card"
                    sx={{
                        // width: 470,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: 2,
                        boxShadow: 2,

                    }}
                >
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                {renderField({
                                    label: 'Offer Name',
                                    name: 'offerName'
                                })}
                            </Grid>
                            <Grid item xs={12}>
                                <SoftBox sx={{ width: '100%' }}>
                                    <SoftTypography component="label" variant="caption" fontWeight="bold">
                                        Description<span style={{ color: 'red' }}>*</span>
                                    </SoftTypography>
                                    <SoftInput
                                        name="description"
                                        multiline
                                        rows={3}
                                        placeholder="Write Offer Description"
                                        value={formik.values.description}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.description && Boolean(formik.errors.description)}
                                    />

                                    {formik.touched.description && formik.errors.description && (
                                        <SoftTypography variant="caption" color="error" sx={{ color: 'red' }}>
                                            {formik.errors.description}
                                        </SoftTypography>
                                    )}
                                </SoftBox>
                            </Grid>

                            <Grid item xs={6}>
                                {renderField({
                                    label: 'Select Status',
                                    name: 'status',
                                    type: 'text',
                                    isSelect: true,
                                    options: statuses,
                                })}
                            </Grid>

                            <Grid item xs={6}>
                                {renderField({
                                    label: 'Select Type',
                                    name: 'type',
                                    type: 'text',
                                    isSelect: true,
                                    options: types,
                                })}
                            </Grid>

                            <Grid item xs={6}>
                                {renderField({
                                    label: 'Select Category',
                                    placeholder: "Search Category...",
                                    name: 'category',
                                    type: 'text',
                                    isSelect: true,
                                    options: categoryData,
                                    isAutoComplete: true,
                                })}
                            </Grid>

                            <Grid item xs={6}>
                                {renderField({
                                    label: 'Select Sub Category',
                                    placeholder: "Search Sub Category...",
                                    name: 'subCategory',
                                    type: 'text',
                                    isSelect: true,
                                    options: subCategoryData,
                                    isAutoComplete: true,
                                    isDisabled: categoryData.length === 0,
                                })}
                            </Grid>

                            <Grid item xs={6}>
                                {renderField({
                                    label: 'Select Business',
                                    placeholder: "Search Bussiness...",
                                    name: 'business',
                                    type: 'text',
                                    isSelect: true,
                                    options: businessData,
                                    isAutoComplete: true,
                                    isMultiple: true,
                                })}
                            </Grid>

                            <Grid item xs={6}>
                                {renderField({
                                    label: 'Start Day',
                                    name: 'startDate',
                                    type: 'datetime-local',
                                })}
                            </Grid>

                            <Grid item xs={6}>
                                {renderField({
                                    label: 'End Day',
                                    name: 'endDate',
                                    type: 'datetime-local',
                                })}
                            </Grid>

                            <Grid item xs={6}>
                                {renderField({
                                    label: 'Usage Count',
                                    name: 'usageCount',
                                    type: 'number',
                                })}
                            </Grid>

                            <Grid item xs={12} display="flex" gap={2}>
                                <SoftButton type="submit" variant="gradient"
                                    color="info"
                                >
                                    Submit
                                </SoftButton>
                                <SoftButton type="button" variant="outlined"
                                    color="info" onClick={() => navigate(-1)}>
                                    Back
                                </SoftButton>
                            </Grid>
                        </Grid>
                    </form>
                </Card>
            </SoftBox>
        </DashboardLayout>
    );
};

export default CreateOfferForm;
